import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class InvoiceIncomingModel extends Model {
  static reducer(action, InvoiceIncomingModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.InvoiceIncoming.schema:
        action.payload.forEach((payload) => {
          const dbData = InvoiceIncomingModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          InvoiceIncomingModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
InvoiceIncomingModel.modelName = "InvoiceIncomingModel";

InvoiceIncomingModel.fields = {
  id: attr(),
};

export default InvoiceIncomingModel;